<div class="leave__shadow shadow"></div>
<div class="leave__popup popup">
  <div class="popup__title">You’re leaving iCreditWorks now.</div>
  <div class="font-medium">
    iCreditWorks’ terms, privacy, and security<br />
    policies do not apply to the site you’re about to<br />
    visit. Please review its terms, privacy, and their<br />
    security policies to see how they apply to you.<br />
    iCreditWorks is not responsible for and does not<br />
    provide any products, services, or content at<br />
    this third-party site.
  </div>
  <div class="popup__buttons d-flex background-white">
    <div (click)="cancelLeave()" class="button">Cancel</div>
    <div (click)="leave()" class="button button_right">Continue</div>
  </div>
</div>
